import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="handshakes"
export default class extends Controller {
  connect() {
    console.log("handshakes")
  }
}
